import { eventUpgrades } from "@/game/entities/config/upgrades/event";
import useUpgradesStore from "@/store/useUpgradesStore";

/** Zero event-scoped upgrade levels in the local store (new event id without generation bump) */
export function resetEventUpgradeLevels(): void {
	const upgradesStore = useUpgradesStore();
	for (const upgradeId of eventUpgrades.keys()) {
		upgradesStore.setUpgradeLevelById(upgradeId, 0);
	}
}
